import { useTranslation } from "react-i18next";
import { Button } from "../../../components/ui/button/index.js";
import {
  AlertDialog,
  AlertDialogActions,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog/index.js";

export function TemplateUnsavedChangesDialog({
  open,
  onStay,
  onDiscard,
}: {
  open: boolean;
  onStay: () => void;
  onDiscard: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onStay();
      }}
    >
      <AlertDialogContent>
        <AlertDialogTitle>{t("whatsapp.templates.manage.unsavedTitle")}</AlertDialogTitle>
        <AlertDialogDescription>
          {t("whatsapp.templates.manage.unsavedBody")}
        </AlertDialogDescription>
        <AlertDialogActions>
          <Button type="button" variant="outline" size="sm" onClick={onStay}>
            {t("whatsapp.templates.manage.unsavedStay")}
          </Button>
          <Button
            type="button"
            size="sm"
            onClick={onDiscard}
            data-testid="template-editor-discard"
          >
            {t("whatsapp.templates.manage.unsavedDiscard")}
          </Button>
        </AlertDialogActions>
      </AlertDialogContent>
    </AlertDialog>
  );
}
